<template>
  <div>
    <Head :title="`${form.mark}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/cars">Авто</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.mark }} {{ form.model }} {{ form.grn }}
    </h1>
    <trashed-message v-if="car.deleted_at" class="mb-6" @restore="restore"> Этот автомобиль был удален. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.mark" :error="form.errors.mark" class="pb-8 pr-6 w-full lg:w-1/2" label="Марка" />
          <text-input v-model="form.model" :error="form.errors.model" class="pb-8 pr-6 w-full lg:w-1/2" label="Модель" />
          <text-input v-model="form.grn" :error="form.errors.grn" class="pb-8 pr-6 w-full lg:w-1/2" label="ГРН" />
          <text-input v-model="form.color" :error="form.errors.color" class="pb-8 pr-6 w-full lg:w-1/2" label="Цвет" />
          <text-input v-model="form.seats" :error="form.errors.seats" class="pb-8 pr-6 w-full lg:w-1/2" label="Мест" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Телефон" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!car.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Удалить автомобиль</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Сохранить автомобиль</loading-button>
        </div>
      </form>
    </div>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mt-8">
      <div class="flex flex-wrap -mb-8 -mr-6 p-8">
        <div class="mb-2 w-full">
          <strong>Создан: </strong>{{ car.created_at }}
        </div>
        <div class="mb-8 w-full">
          <strong>Привязка к телеграм боту:</strong>
          <span v-if="!car.telegraph_chat"> не подключен. ПИН: <strong>{{ car.pin_code }}</strong></span>
          <span v-if="car.telegraph_chat"> c {{ car.telegraph_chat.created_at }}, {{ car.telegraph_chat.name }}</span>
          <button v-if="car.telegraph_chat" class="text-red-600 hover:underline; pl-4" tabindex="-1" type="button" @click="unlink">Отвязать</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    car: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        mark: this.car.mark,
        model: this.car.model,
        grn: this.car.grn,
        color: this.car.color,
        seats: this.car.seats,
        phone: this.car.phone,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/cars/${this.car.id}`)
    },
    destroy() {
      if (confirm('Вы уверены что хотите удалить автомобиль?')) {
        this.$inertia.delete(`/cars/${this.car.id}`)
      }
    },
    restore() {
      if (confirm('Вы уверены что хоите восстановить автомобиль?')) {
        this.$inertia.put(`/cars/${this.car.id}/restore`)
      }
    },
    unlink() {
      if (confirm('Вы уверены что хотите отвязать автомобиль от телеграм бота? После этого появится новый пин-код который можно будет использовать для повторной привязки')) {
        this.$inertia.put(`/cars/${this.car.id}/unlink`)
      }
    },
  },
}
</script>
